<template>
  <Vue-select
    class="custom-vue-select"
    v-model="selectedInternal"
    :options="data"
    label="name"
    placeholder="Escribir..."
    :reduce="data => data.id.toString()"
    :components="{ Deselect }"
  >
    <template v-slot:no-options="{ data, searching }">
      <template v-if="searching">
        <em style="opacity: 0.5">No se encontraron resultados {{ data }}</em>
      </template>
      <em v-else style="opacity: 0.5">No se encontraron resultados</em>
    </template>
  </Vue-select>
</template>

<script>
import { ref, watchEffect } from 'vue';

export default {
  props: {
    selectedWodedsType: String,
  },
  setup(props, { emit }) {
    const data = ref([]);
    const types = [
      { id: 'Grave', name: 'Grave' },
      { id: 'Leve', name: 'Leve' },
      { id: 'Mortal' , name: 'Mortal' },
    ];
    const selectedInternal = ref(null);

    data.value = types;

    watchEffect(() => {
      if (props.selectedWodedsType) {
        const selectedOption = data.value.find(option => option.id === props.selectedWodedsType);
        selectedInternal.value = selectedOption;
      }
    });

    watchEffect(() => {
      if (selectedInternal.value !== null) {
        if (selectedInternal.value) {
          const selectedId = selectedInternal.value.id;

          const idAsString = selectedId ? selectedId.toString() : null;
          emit('update:selectedWodedsType', selectedInternal.value);
          if (idAsString) {
            selectedInternal.value = idAsString;
            emit('update:selectedWodedsType', idAsString);
          }
        }
      }
    });

    const Deselect = null;

    return {
      selectedInternal,
      data,
      Deselect,
    };
  },
};
</script>
